<!--
  @component
  Generates an SVG bar chart.
 -->
<script>
  import { getContext } from "svelte";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

  const { data, x, xGet, yGet, xScale, yScale, custom } = getContext("LayerCake");

  /**
   * @typedef {Object}
   * @property {boolean} labeled - whether to display axis labels for this chart
   * @property {string} label - what text to show if labeled is true
   */
  let { labeled = false, label = "" } = $props();
</script>

<line
  x1={$xScale(0)}
  x2={$xScale(0)}
  y1={$yScale.range()[0] - 15}
  y2={$yScale.range()[1] + 15}
  stroke-width="1"
  stroke={urbanColors.gray_shade_dark}
/>
<line
  x1={$xScale.range()[0]}
  x2={$xScale.range()[1]}
  y1={$yScale.range()[1] + 15}
  y2={$yScale.range()[1] + 15}
  stroke-width="1"
  stroke={urbanColors.gray_shade_dark}
></line>
{#if labeled}
  {#each label.split(" ") as word, i}
    <text
      class="axis-label"
      x={($xScale.range()[0] + $xScale.range()[1]) / 2}
      y={$yScale.range()[1] + 15 * (i +2.25)}
      text-anchor="middle">{word}</text
    >
  {/each}
{/if}
<g class="bar-group">
  {#each $data as d, i}
    <g>
      <rect
        class="group-rect"
        data-id={i}
        x={Math.min($xScale(0), $xGet(d))}
        y={$yGet(d)}
        height={$yScale.bandwidth()}
        width={Math.abs($xGet(d) - $xScale(0))}
        fill={$custom.seriesColors[i]}
      ></rect>
      <g>
        {#key d + d[$custom.xKey]}
          <text
            class="label"
            x={$x(d) < 0 ? $xScale(0) + 5 : $xGet(d) + 5}
            y={$yGet(d) + $yScale.bandwidth() / 2 + 6}
            fill={$custom.seriesColors[i] == "transparent" ? "transparent" : "black"}
            text-anchor="start">{$custom.format.format($x(d))}</text
          >
        {/key}
      </g>
    </g>
  {/each}
</g>

<style>
  .axis-label {
    font-size: 14px;
    /* font-weight: 700; */
    font-style: italic;
  }
</style>
